import { Carousel, Grid } from "@scuf/common";
import DatTab from "../../components/common/DatTab/DatTab";

const Aplicaciones = () => {
  // Variable que controla el valor del Grid de la pantalla
  const graftWidth = 12;

  return (
    <>
      <Carousel
        className="carousel-custom carousel-custom-600"
        autoPlay={true}
        transitionTime={10000}
      >
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <Grid.Row>
                <Grid.Column
                  xsWidth={graftWidth}
                  sWidth={graftWidth}
                  mWidth={graftWidth}
                  lWidth={graftWidth}
                  xlWidth={graftWidth}
                >
                  <div>
                    <DatTab
                      url="sp_GetData"
                      body={{ params: "020903" }}
                      isCard="0"
                      titleCard="APLICACIONES PROFIT APAGADAS: CHUQUICAMATA"
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <Grid.Row>
                <Grid.Column
                  xsWidth={graftWidth}
                  sWidth={graftWidth}
                  mWidth={graftWidth}
                  lWidth={graftWidth}
                  xlWidth={graftWidth}
                >
                  <div>
                    <DatTab
                      url="sp_GetData"
                      body={{ params: "021403" }}
                      isCard="0"
                      titleCard="APLICACIONES PROFIT APAGADAS: RADOMIRO TOMIC"
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <Grid.Row>
                <Grid.Column
                  xsWidth={graftWidth}
                  sWidth={graftWidth}
                  mWidth={graftWidth}
                  lWidth={graftWidth}
                  xlWidth={graftWidth}
                >
                  <div>
                    <DatTab
                      url="sp_GetData"
                      body={{ params: "021003" }}
                      isCard="0"
                      titleCard="APLICACIONES PROFIT APAGADAS: MINISTRO HALES"
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <Grid.Row>
                <Grid.Column
                  xsWidth={graftWidth}
                  sWidth={graftWidth}
                  mWidth={graftWidth}
                  lWidth={graftWidth}
                  xlWidth={graftWidth}
                >
                  <div>
                    <DatTab
                      url="sp_GetData"
                      body={{ params: "021503" }}
                      isCard="0"
                      titleCard="APLICACIONES PROFIT APAGADAS: GABRIELA MISTRAL"
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <Grid.Row>
                <Grid.Column
                  xsWidth={graftWidth}
                  sWidth={graftWidth}
                  mWidth={graftWidth}
                  lWidth={graftWidth}
                  xlWidth={graftWidth}
                >
                  <div>
                    <DatTab
                      url="sp_GetData"
                      body={{ params: "021103" }}
                      isCard="0"
                      titleCard="APLICACIONES PROFIT APAGADAS: SALVADOR"
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <Grid.Row>
                <Grid.Column
                  xsWidth={graftWidth}
                  sWidth={graftWidth}
                  mWidth={graftWidth}
                  lWidth={graftWidth}
                  xlWidth={graftWidth}
                >
                  <div>
                    <DatTab
                      url="sp_GetData"
                      body={{ params: "021203" }}
                      isCard="0"
                      titleCard="APLICACIONES PROFIT APAGADAS: ANDINA"
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </div>
          }
        ></Carousel.Slide>
        <Carousel.Slide
          theme="dark"
          content={
            <div>
              <Grid.Row>
                <Grid.Column
                  xsWidth={graftWidth}
                  sWidth={graftWidth}
                  mWidth={graftWidth}
                  lWidth={graftWidth}
                  xlWidth={graftWidth}
                >
                  <div>
                    <DatTab
                      url="sp_GetData"
                      body={{ params: "021303" }}
                      isCard="0"
                      titleCard="APLICACIONES PROFIT APAGADAS: EL TENIENTE"
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </div>
          }
        ></Carousel.Slide>
      </Carousel>
    </>
  );
};

export default Aplicaciones;
